export const supportedCompetitionVideoExt = [
  "mp4",
  "avi",
  "mov",
  "wmv",
  "mkv",
  "webm",
  "mpeg",
  "mpg",
  "3gp",
];

export const supportedCompetitionImageExt = [
  "jpg",
  "jpeg",
  "png",
  "webp",
  "gif",
  "heic",
  "heif",
];

export const competitionMediaAccept =
  "video/*,image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif";

/** File picker: videos only (fashion dress video, etc.) */
export const dressVideoAccept = [
  ...supportedCompetitionVideoExt.map((ext) => `.${ext}`),
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/x-msvideo",
  "video/3gpp",
  "video/mpeg",
].join(",");

/** File picker: images only (fashion dress image, banners, etc.) */
export const dressImageAccept = [
  ...supportedCompetitionImageExt.map((ext) => `.${ext}`),
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/heic",
  "image/heif",
].join(",");

export function getFileExtension(file) {
  if (!file?.name) return "";
  return file.name.split(".").pop()?.toLowerCase() || "";
}

export function isCompetitionImageFile(file) {
  if (!file) return false;
  const ext = getFileExtension(file);
  const typePart = file.type?.split("/")[1]?.replace("jpeg", "jpg");
  return (
    supportedCompetitionImageExt.includes(ext) ||
    (typePart && supportedCompetitionImageExt.includes(typePart))
  );
}

export function isCompetitionVideoFile(file) {
  if (!file) return false;
  const ext = getFileExtension(file);
  const typePart = file.type?.split("/")[1];
  return (
    supportedCompetitionVideoExt.includes(ext) ||
    (typePart && supportedCompetitionVideoExt.includes(typePart))
  );
}

export function inferMediaTypeFromUrl(url = "") {
  const clean = String(url).split("?")[0].split("#")[0].toLowerCase();
  const ext = clean.split(".").pop() || "";
  if (supportedCompetitionImageExt.includes(ext)) return "image";
  if (supportedCompetitionVideoExt.includes(ext)) return "video";
  return "video";
}

export function resolveCompetitionMediaType(item) {
  if (!item) return "video";
  const explicit = item.media_type || item.mediaType;
  if (explicit === "image" || explicit === "video") return explicit;
  return inferMediaTypeFromUrl(item.video_url || item.thumbnail);
}

export function isCompetitionImageMedia(item) {
  return resolveCompetitionMediaType(item) === "image";
}
